import React, { FC, KeyboardEvent, useRef, useState } from "react";
import {
  Container,
  VideoDescWrapper,
  PlayBackground,
  VideoTitle,
  VideoSubTitle,
  DismissButton,
} from './styles'
import BigPlay from './big-play.svg'
import CloseIcon from './close.svg'
import Dialog from "../dialog";
type VideoProp = {
  url?:string,
  img?:any,
  title:string,
  subtitle:string,
  dismissible?:boolean,
  onDismiss?:() => void,
}

const TutorialVodeo:FC<VideoProp> = (props) => {
  const [active, setActive] = useState<boolean>(false)
  const [activeVideo, setActiveVideo] = useState<boolean>(false)
  const [dismissed, setDismissed] = useState<boolean>(false)
  const IframeRef:any = useRef()
  const {
    url,
    img,
    title,
    subtitle,
    dismissible = true,
    onDismiss,
  } = props
  let videoStopper = function(id:any) {
    let containerElement:any = document.getElementById(id);
    let iframe_tag = containerElement?.querySelector( 'iframe');
    let video_tag = containerElement?.querySelector( 'video' );
    if ( iframe_tag) {
        let iframeSrc = iframe_tag.src;
        iframe_tag.src = iframeSrc; 
    }
    if ( video_tag) {
        video_tag.pause();
    }
  }
  const handleOpen = () => {
    if(url){
      setActive(true)
      setTimeout(() => {
        setActiveVideo(true)
      },200)
    }
  }
  const handleKeyDown = (event:KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleOpen()
    }
  }
  const handleDismiss = (event:React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setDismissed(true)
    onDismiss?.()
  }

  if (dismissed) {
    return null
  }

  return (
    <>
      <Container
        role="button"
        tabIndex={url ? 0 : -1}
        aria-disabled={!url}
        aria-label={`${title}: ${subtitle}`}
        onClick={handleOpen}
        onKeyDown={handleKeyDown}
        style={img ? {backgroundImage:`url(${img})`} : undefined}
      >
        {dismissible && (
          <DismissButton type="button" aria-label="Dismiss video" onClick={handleDismiss}>
            <img src={CloseIcon} alt="" aria-hidden="true" />
          </DismissButton>
        )}
        <VideoDescWrapper>
          <PlayBackground>
            <img alt="" src={BigPlay}/>
          </PlayBackground>
          <VideoTitle>
            {title}
          </VideoTitle>
          <VideoSubTitle>
            {subtitle}
          </VideoSubTitle>
        </VideoDescWrapper>
      </Container>
      {active &&
        <Dialog  handleClose={() => {
          videoStopper("videoContainer")
          setActive(false)
          setTimeout(() => {
            setActiveVideo(false)
          },200)
          }} active={activeVideo} open={active}>
          {/* <div style={{width:'90vw'}}> */}
          <iframe
            ref={IframeRef}
            style={{
              width:'100%',
              height:'auto',
              maxHeight:'100%',
              aspectRatio:'16 / 9',
              backgroundColor:"black",
              border:'none',
            }}
            src={url}
            allow='autoplay; encrypted-media'

            title='video'
          />
          {/* </div> */}
        </Dialog>
      }
    </>
  )
}

export default TutorialVodeo
